import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: 20,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
  },
}));

const SkeletonState = (props) => {
  const classes = useStyles();
  if (props.forComment) {
    return (
      <>
        {Array.from(new Array(5)).map((value, index) => {
          return (
            <div key={index}>
              <Skeleton variant="text" />
            </div>
          );
        })}
      </>
    );
  } else {
    return (
      <>
        {Array.from(new Array(3)).map((value, index) => {
          return (
            <Paper key={index} elevation={0} className={classes.paper}>
              <Skeleton variant="text" width="80%" height={30} />
              <Skeleton variant="text" width="60%" height={30} />
              <Skeleton variant="rect" height={140} />
              <Skeleton variant="text" width="30%" height={30} />
              <Divider variant="middle" />
            </Paper>
          );
        })}
      </>
    );
  }
};

export default SkeletonState;
